import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import api, { apiErrorMsg } from "@/lib/api";
import { toast } from "sonner";
import PrintCatatanSiku from "@/components/PrintCatatanSiku";

export default function HasilPage() {
  const { periodeId } = useParams();
  const [data, setData] = useState(null);
  const [siswaIdx, setSiswaIdx] = useState(0);

  useEffect(() => {
    api.get(`/pengasuh/periode/${periodeId}/hasil`).then((r) => setData(r.data)).catch((e) => toast.error(apiErrorMsg(e)));
  }, [periodeId]);

  if (!data) return <div className="p-4 md:p-8 text-slate-500">Memuat...</div>;
  const current = data.hasil[siswaIdx];

  return (
    <div className="p-4 md:p-8">
      <div className="no-print">
        <Link to="/pengasuh" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-navy-900 mb-4"><ArrowLeft className="w-4 h-4" /> Kembali</Link>
        <div className="mb-4">
          <h1 className="font-heading text-2xl font-bold text-navy-900">Hasil Observasi (Catatan Siku)</h1>
          <p className="text-slate-500 text-sm">{data.periode.jenis === "mingguan" ? "Minggu" : "Bulan"} ke-{data.periode.nomor} • {data.periode.bulan} {data.periode.tahun}</p>
        </div>
        <div className="bg-white border border-slate-200 rounded-sm p-4 mb-4 flex flex-wrap gap-3 items-end">
          <div className="w-full sm:w-auto">
            <label className="block text-xs uppercase font-semibold text-slate-500 mb-1">Pilih Serdik</label>
            <select value={siswaIdx} onChange={(e) => setSiswaIdx(Number(e.target.value))} className="px-3 py-2 border border-slate-300 rounded-sm text-sm bg-white w-full sm:w-auto sm:min-w-[260px]">
              {data.hasil.map((h, i) => <option key={h.siswa.id} value={i}>{i + 1}. {h.siswa.nama} (Rk {data.ranks?.[h.siswa.id] || "—"})</option>)}
            </select>
          </div>
          <button onClick={() => window.print()} className="bg-navy-900 hover:bg-navy-800 text-white px-4 py-2 rounded-sm text-sm font-semibold flex items-center gap-2"><Printer className="w-4 h-4" /> Cetak</button>
        </div>
      </div>
      {current?.catatan_siku && (
        <div className="overflow-x-auto print:overflow-visible"><PrintCatatanSiku settings={data.settings} siswa={current.siswa} rangking={current.rangking} catatan_siku={current.catatan_siku} periode={data.periode} /></div>
      )}
    </div>
  );
}
